import { logger } from './logger';

/**
 * 统一的错误处理装饰器
 */
export function withErrorHandling<T extends (...args: any[]) => any>(
  fn: T,
  errorMessage?: string
): T {
  return (async (...args: Parameters<T>) => {
    try {
      return await fn(...args);
    } catch (error: any) {
      const message = errorMessage || error.message;
      logger.error(message);
      
      if (process.env.DEBUG) {
        console.error('Stack trace:', error);
      }
      
      process.exit(1);
    }
  }) as T;
}

/**
 * 命令错误处理包装器
 */
export function handleCommandError(commandName: string) {
  return (error: any) => {
    logger.error(`Failed to execute '${commandName}':`, error.message);
    
    if (process.env.DEBUG) {
      console.error('Stack trace:', error);
    }
    
    // 提供有用的错误提示
    if (error.code === 'ENOENT') {
      logger.info('Tip: Run "workflow init" first to initialize the workflow system');
    } else if (error.message.includes('not initialized')) {
      logger.info('Tip: Run "workflow init" to set up the workflow system');
    }
    
    process.exit(1);
  };
}

/**
 * 异步操作超时包装器
 */
export function withTimeout<T>(
  promise: Promise<T>,
  timeoutMs: number,
  timeoutMessage?: string
): Promise<T> {
  return Promise.race([
    promise,
    new Promise<T>((_, reject) =>
      setTimeout(
        () => reject(new Error(timeoutMessage || `Operation timed out after ${timeoutMs}ms`)),
        timeoutMs
      )
    )
  ]);
}